module.exports = __webpack_public_path__ + "img/mask.7669e553.svg";